<template>
  <div>
    <el-card>
      <h3>用户留言</h3>
      <el-table :data="tableData" border stripe style="margin-top:15px;">
        <el-table-column prop="id" label="ID" width="80"/>
        <el-table-column prop="userPhone" label="用户手机号" width="140"/>
                <el-table-column label="留言内容">
          <template slot-scope="scope">
            <span class="content-click" @click="showDetail(scope.row)">
              {{ scope.row.content }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.status === 0 ? '#f56c6c' : '#999' }">
              {{ scope.row.status === 0 ? '未读' : '已读' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="提交时间" width="180"/>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === 0"
              size="mini"
              type="primary"
              @click="handleRead(scope.row)"
            >标记已读</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top:15px;text-align:right;"
        background
        layout="total, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="fetchList"
      />
    </el-card>
  </div>
</template>
<script>
import adminRequest from '@/utils/adminRequest'
export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
        showDetail(row) {
      this.$alert(row.content, `留言详情（${row.userPhone}）`, {
        confirmButtonText: '关闭',
        customClass: 'feedback-detail-dialog'
      })
    },
    async fetchList() {
      try {
        const res = await adminRequest.get('/feedbackList', {
          params: { page: this.currentPage, pageSize: this.pageSize }
        })
        this.tableData = (res.data?.list || []).map(item => ({
          id: item.id,
          userPhone: item.user_phone,
          content: item.content,
          status: item.status,
          createTime: item.create_time
        }))
        this.total = res.data?.total || 0
      } catch (err) {
        console.error(err)
        this.tableData = []
      }
    },
    async handleRead(row) {
      try {
        const res = await adminRequest.post('/feedbackRead', { id: row.id })
        if (res.success) {
          this.$message.success('已标记')
          this.fetchList()
        }
      } catch (err) {
        console.error(err)
      }
    },
    async handleDelete(row) {
      this.$confirm(`确定删除这条留言？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await adminRequest.delete('/feedbackDelete', { data: { id: row.id } })
        if (res.success) {
          this.$message.success('已删除')
          this.fetchList()
        }
      }).catch(() => {})
    }
  }
}
</script>
<style>
/* 反馈详情弹窗（全局，因为 el-alert 挂到 body 下，scoped 抓不到） */
.feedback-detail-dialog {
  width: 90% !important;
  max-width: 520px !important;
}
.feedback-detail-dialog .el-message-box__message {
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 60vh;
  overflow-y: auto;
  line-height: 1.7;
  color: #333;
  font-size: 15px;
}
.feedback-detail-dialog .el-message-box__title {
  font-size: 16px;
  color: #409eff;
}
</style>